import React from "react";
import { HMenu } from "./styles";

function HambMenu() {
    return(
        <HMenu>MENU</HMenu>
    )
}

export default HambMenu